import React from "react";
import { DeleteForeverOutlined, WarningAmberOutlined } from "@mui/icons-material";
import ConfirmDialog from "./ConfirmDialog";

/**
 * The only genuinely irreversible action in the panel: it removes the archive
 * row and every photo under both S3 prefixes. Red, and the description says so
 * — the old dialog asked «Видалити з архіву?» with the same two grey buttons
 * the "return to base" dialog used.
 */
const BeforeDeleteArchive = ({
  openDialog,
  id,
  deleteObject,
  handleCloseDialog,
}) => {
  const confirm = function () {
    handleCloseDialog();
    deleteObject(id);
  };

  return (
    <ConfirmDialog
      open={openDialog}
      onClose={handleCloseDialog}
      onConfirm={confirm}
      tone="danger"
      icon={<WarningAmberOutlined />}
      title="Видалити назавжди?"
      description="Об'єкт і всі його фото буде видалено остаточно. Цю дію не можна скасувати."
      confirmLabel="Видалити"
      confirmIcon={<DeleteForeverOutlined />}
    />
  );
};

export default BeforeDeleteArchive;
